import React, { useEffect, useMemo } from "react";
import actions from "../../Store/actions";
import { useDispatch, useSelector } from "react-redux";
import { uverifiTheme, cvTheme, neutralTheme } from "../styles";
import config from "../../config";

/**
 * Use Theme Hook Attributes Hook
 */
export default () => {
    /** Store image and all the  themes from localstorage */
    const { auth, organisation, appSettings, typesList } = useSelector(
        (state) => state
    );
    const dispatch = useDispatch();
    const { themeName } = appSettings;
    const { baseUrl } = config.api;
    // If present check if it has theme
    const cvSelectedTheme = localStorage.getItem("cvSelectedTheme");
    const cvOrgConfig = localStorage.getItem("cvOrgConfig");

    const isCheckVentory = baseUrl.includes("checkventory");
    const currentEnvTheme = isCheckVentory ? cvTheme : uverifiTheme;

    const currentOrgTheme = useMemo(() => {
        if (typesList.organisationThemes) {
            const res = typesList.organisationThemes.data.find(
                (item) => item.organisation.id === organisation.id
            );

            if (res) {
                const themeData = JSON.parse(res.pwaTheme.replace(/'/g, '"'));
                if (res.pwaTheme.length > 0) {
                    /** Store themes and logo */
                    const cvOrgConfig = JSON.stringify({
                        themes: themeData,
                        darkLogo: res.darkLogo,
                        lightLogo: res.lightLogo,
                        privacyUrl: organisation.privacyPolicy,
                        supportUrl: organisation.supportUrl,
                    });
                    localStorage.setItem("cvOrgConfig", cvOrgConfig);
                }
            }
            /** If there is no res fallback to checkventory*/
            return res ? res : currentEnvTheme;
        } /*If typesList is not loaded*/ else return currentEnvTheme;
    }, [typesList.organisationThemes, organisation]);

    useEffect(() => {
        if (auth.identityId) {
            dispatch(actions.organisation.create.getRequest());
        }
    }, [auth]);

    const getCurrentTheme = (orgTheme) => {
        const selectedTheme = cvSelectedTheme ? cvSelectedTheme : "";

        if (selectedTheme === "original") return cvTheme;
        if (selectedTheme === "neutral") return neutralTheme;
        if (selectedTheme === "org") {
            const orgConfig = cvOrgConfig ? JSON.parse(cvOrgConfig) : null;
            if (orgConfig) {
                /** If orgConfig has themes and themes are not empty */
                return Object.keys(orgConfig.themes).length > 0
                    ? orgConfig.themes
                    : currentEnvTheme;
            } /** If nothing returned currentTheme */ else
                return currentEnvTheme;
        } else {
            // On first load set theme to org default
            localStorage.setItem("cvSelectedTheme", "org");
            // load org theme if exists
            if (orgTheme && orgTheme.pwaTheme) return orgTheme.pwaTheme;

            //otherwise load theme based on the url instance
            return currentEnvTheme;
        }
    };

    //Check if the org request is loaded
    const next = useMemo(() => {
        const orgConfig = cvOrgConfig ? JSON.parse(cvOrgConfig) : null;
        if (!orgConfig) {
            /** If no theme is present load orginal theme */
            return currentEnvTheme;
        } else {
            const currentTheme = getCurrentTheme(currentOrgTheme);
            /** if there is theme in org return themes */
            if (currentTheme && Object.keys(currentTheme).length > 0)
                return currentTheme;
            /** if there is no theme in org return themes */ else
                return currentEnvTheme;
        }
    }, [
        organisation,
        cvOrgConfig,
        cvSelectedTheme,
        themeName,
        currentOrgTheme,
    ]);

    return next;
};
